import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { processSteps } from '../data/process';
import { SectionHeading } from './SectionHeading';
export function ProcessSection() {
  const {
    language,
    t
  } = useLanguage();
  return <section id="process" className="bg-ivory px-5 py-24 md:px-8 md:py-32 lg:px-12" data-id="element-104" data-mp="p32sp99g8m2m">
      <div className="mx-auto max-w-[1440px]" data-id="element-105" data-mp="1mql7b0pskiej">
        <SectionHeading kicker={t.process.kicker} headline={t.process.headline} description={t.process.description} data-id="element-106" data-mp="1mp9vqeq3u6cv" />
        <div className="mt-16 grid border-t border-ink/20 md:grid-cols-2 lg:grid-cols-4" data-id="element-107" data-mp="1hs9y8s7bmbxd">
          {processSteps.map((step, index) => <motion.article key={step.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          delay: index * 0.04,
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex min-h-[270px] flex-col border-b border-ink/20 py-7 md:px-6 md:first:pl-0 lg:border-r lg:last:border-r-0" data-id="element-108" data-mp="181yhg52jg892" data-mpi={index}>
              <span className="font-display text-2xl italic text-burgundy" data-id="element-109" data-mp="26365cpphld50">{step.number}</span>
              <h3 className="mt-auto text-sm font-semibold uppercase tracking-[0.14em] text-ink" data-id="element-110" data-mp="2b0xtr9qxah4g">{step.title[language]}</h3>
              <p className="mt-4 text-sm leading-relaxed text-ink/60" data-id="element-111" data-mp="1waqmzraa2mjl">{step.description[language]}</p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}